<template>
  <div class="recaptcha color--lg">
    <p>
      <fa-icon
        class="color--ter margin__r--6"
        :icon="['fal', 'shield-check']"
      />

      {{ t('literal.protected_by_recaptcha') }}
    </p>

    <ul class="recaptcha__ul">
      <li class="recaptcha__li">
        <a
          class="link__color--lg-ter"
          :href="`https://policies.google.com/privacy?hl=${locale}`"
          target="_blank"
          rel="noreferrer"
        >
          {{ t('literal.privacy') }}
        </a>
      </li>

      <li>
        <a
          class="link__color--lg-ter"
          :href="`https://policies.google.com/terms?hl=${locale}`"
          target="_blank"
          rel="noreferrer"
        >
          {{ t('literal.terms') }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useI18n } from '@/vendors/i18n'
import { useLanguageStore } from '@/stores/LanguageStore'

const { t } = useI18n()
const { locale } = storeToRefs(useLanguageStore())
</script>

<style scoped lang="scss">
.recaptcha {
  font-size: rem(14px);
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex-wrap: wrap;
  text-align: center;

  @include mq(sm) {
    flex-direction: row;
  }

  &__ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    @include mq(sm) {
      &::before {
        content: '|';
        margin: 0 4px;
      }
    }
  }

  &__li {
    &:not(:last-child) {
      &::after {
        content: '-';
        margin: 0 4px;
      }
    }
  }
}
</style>